import script from "./PrivacyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyCard.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyCard.vue?vue&type=style&index=0&id=a255042e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a255042e"]])

export default __exports__